import { gql } from '@apollo/client';

export const MARKETING_PREFERENCES_FORM_BLOCK_QUERY = gql`
 query MarketingPreferencesFormBlockQuery {
    textFor {
      heading: pair(pairKey: "marketingPrefsFormBlockHeading") {
        key
        value
      }

      subheading: pair(pairKey: "marketingPrefsFormBlockSubHeading") {
        key
        value
      }
    }
    userInfo {
      email,
      response {
        success,
        errors {
          status
        }
      }
    }
  }
`;
